// Prompt 19 product decisions are pending. Requests and explicitly unqualified
// host confirmations remain available; protected reservations stay gated.
export const viewingPolicy={configured:false,version:1,timeZone:null,protectListing:null,protectHost:null,rescheduleBy:null,cancellation:null};
export const viewingTimeZone=()=>viewingPolicy.timeZone||Intl.DateTimeFormat().resolvedOptions().timeZone;
